const MIB = 1024 * 1024;

/** Largest single `.pack` byte size under `.git/objects/pack`, or 0 if missing/unreadable. */
export async function getLargestPackfileBytes(root: FileSystemDirectoryHandle): Promise<number> {
  try {
    const git = await root.getDirectoryHandle(".git", { create: false });
    const packDir = await git.getDirectoryHandle("objects/pack", { create: false });
    let max = 0;
    for await (const [name, h] of packDir.entries()) {
      if (h.kind !== "file" || !name.endsWith(".pack")) continue;
      try {
        const fh = await packDir.getFileHandle(name);
        const f = await fh.getFile();
        if (f.size > max) max = f.size;
      } catch {
        /* skip unreadable */
      }
    }
    return max;
  } catch {
    return 0;
  }
}

export function formatPackSizeMiB(bytes: number): string {
  return `${(bytes / MIB).toFixed(1)} MiB`;
}

/** Soft warning from this size upward — whole pack may stress tab memory. */
export const LARGE_PACK_WARN_BYTES = 24 * 1024 * 1024;

/**
 * Stronger warning threshold. We do not block Git commands (no repo changes required);
 * isomorphic-git still loads entire `.pack` files, so very large packs may OOM or fail.
 */
export const VERY_LARGE_PACK_WARN_BYTES = 96 * 1024 * 1024;
